import {
  GET_AGEING_PARAMETER_FAILURE,
  GET_AGEING_PARAMETER_REQUEST,
  GET_AGEING_PARAMETER_SUCCESS,
  GET_MVT_BY_DOC_FAILURE,
  GET_MVT_BY_DOC_REQUEST,
  GET_MVT_BY_DOC_SUCCESS,
  GET_PICKLIST_AGEING_DOWNLOAD_FAILURE,
  GET_PICKLIST_AGEING_DOWNLOAD_RANGE_FAILURE,
  GET_PICKLIST_AGEING_DOWNLOAD_RANGE_REQUEST,
  GET_PICKLIST_AGEING_DOWNLOAD_RANGE_SUCCESS,
  GET_PICKLIST_AGEING_DOWNLOAD_REQUEST,
  GET_PICKLIST_AGEING_DOWNLOAD_SUCCESS,
  GET_PICKLIST_AGEING_FAILURE,
  GET_PICKLIST_AGEING_REQUEST,
  GET_PICKLIST_AGEING_SUCCESS,
} from "./picklistAgeingTypes";
import axios from "axios";
import Config from "../../../config/index";

let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getPicklistAgeingRequest = () => {
  return {
    type: GET_PICKLIST_AGEING_REQUEST,
  };
};

const getPicklistAgeingSuccess = (payload) => {
  return {
    type: GET_PICKLIST_AGEING_SUCCESS,
    payload: payload,
  };
};

const getPicklistAgeingFailure = (error) => {
  return {
    type: GET_PICKLIST_AGEING_FAILURE,
    payload: error,
  };
};

const getPicklistAgeing = (
  pageNo,
  rowsPerPage,
  search,
  documentTypeSelected,
  movementTypeSelected,
  parameterSelected,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPicklistAgeingRequest());
    // let url = `${baseUrlReport}/reports/picklist_ageing?documentId=${documentTypeSelected}&mvtId=${movementTypeSelected}&ageingValue=${parameterSelected}`;

    let url = `${baseUrlReport}/picklist_ageing?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&documentId=${documentTypeSelected}&mvtId=${movementTypeSelected}&ageingValue=${parameterSelected}&startDate=""&endDate=""`;
    axios
      .get(url, headers)
      .then((response) => {

        dispatch(getPicklistAgeingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPicklistAgeingFailure(err.message));
      });
  };
};

const getPicklistAgeingDownloadRequest = () => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_REQUEST,
  };
};

const getPicklistAgeingDownloadSuccess = (payload) => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getPicklistAgeingDownloadFailure = (error) => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getPicklistAgeingDownload = (
  pageNo,
  rowsPerPage,
  search,
  documentTypeSelected,
  movementTypeSelected,
  parameterSelected,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPicklistAgeingDownloadRequest());
    // let url = `${baseUrl}/reports/picklist_ageing?documentId=${documentTypeSelected}&mvtId=${movementTypeSelected}&ageingValue=${parameterSelected}`;

    let url = `${baseUrlReport}/picklist_ageing?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&documentId=${documentTypeSelected}&mvtId=${movementTypeSelected}&ageingValue=${parameterSelected}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPicklistAgeingDownloadSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getPicklistAgeingDownloadFailure(err.message));
      });
  };
};

const getAgeingParameterRequest = () => {
  return {
    type: GET_AGEING_PARAMETER_REQUEST,
  };
};

const getAgeingParameterSuccess = (payload) => {
  return {
    type: GET_AGEING_PARAMETER_SUCCESS,
    payload: payload,
  };
};

const getAgeingParameterFailure = (error) => {
  return {
    type: GET_AGEING_PARAMETER_FAILURE,
    payload: error,
  };
};

const getAgeingParameter = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAgeingParameterRequest());
    let url = `${baseUrl}/reports/ageing/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAgeingParameterSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getAgeingParameterFailure(err.message));
      });
  };
};
const getMovementByDocumentIdRequest = () => {
  return {
    type: GET_MVT_BY_DOC_REQUEST,
  };
};

const getMovementByDocumentIdSuccess = (payload) => {
  return {
    type: GET_MVT_BY_DOC_SUCCESS,
    payload: payload,
  };
};

const getMovementByDocumentIdFailure = (error) => {
  return {
    type: GET_MVT_BY_DOC_FAILURE,
    payload: error,
  };
};

const getMovementByDocumentId = (documentTypeSelected, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getMovementByDocumentIdRequest());
    let url = `${baseUrl}/document_mvt_map/by_doc_id?documentId=${documentTypeSelected}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMovementByDocumentIdSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getMovementByDocumentIdFailure(err.message));
      });
  };
};

const downloadPicklistAgeingRequest = () => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_RANGE_REQUEST,
  };
};

const downloadPicklistAgeingSuccess = (payload) => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_RANGE_SUCCESS,
    payload: payload,
  };
};

const downloadPicklistAgeingFailure = (error) => {
  return {
    type: GET_PICKLIST_AGEING_DOWNLOAD_RANGE_FAILURE,
    payload: error,
  };
};

const downloadPicklistAgeing = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  documentTypeSelected,
  movementTypeSelected,
  parameterSelected,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadPicklistAgeingRequest());
    let url = `${baseUrlReport}/picklist_ageing?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&documentId=${documentTypeSelected}&mvtId=${movementTypeSelected}&ageingValue=${parameterSelected}`;
    
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadPicklistAgeingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadPicklistAgeingFailure(err.response));
      });
  };
};

export {
  getPicklistAgeing,
  getAgeingParameter,
  getMovementByDocumentId,
  getPicklistAgeingDownload,
  downloadPicklistAgeing,
};
